// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import MinusSvg from '@rsuite/icon-font/lib/action/Minus';
var Minus = createSvgIcon({
  as: MinusSvg,
  ariaLabel: 'minus',
  category: 'action',
  displayName: 'Minus'
});
export default Minus;